import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { OnboardingKeysCombined } from '../../constants/onboarding-keys-combined';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql';

/**
 * Centralized preloader that fetches ALL onboarding state keys.
 * This ensures that subsequent calls to useGetOnboardingState will hit the cache
 * regardless of which subset of keys they request.
 *
 * When the experiment `confluence_centralized_onboarding_state` is enabled,
 * all onboarding state queries will use the same set of keys (OnboardingKeysCombined),
 * which guarantees cache hits.
 */
export const preloadAllOnboardingState = (): Promise<{
	data: unknown;
	hasErrors: boolean;
}> => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: OnboardingKeysCombined,
		},
	});
};
